export * from './lib/tag-input.module';
export * from './lib/components/tag-input/tag-input.component';



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/angular2-tag-input/index.ts